import { merge } from 'utils/Sidebar';

const _ = require('lodash');

const ROUTES = {
  '/dashboard': 'dashbordFilter',
  '/scorecard': 'filter',
  '/analytics': 'analyticsfilter',
  '/evaluation': 'evaluationfilter',
  '/inspect': 'analyzefilter'
};

function mergeObjectData(child, parent) {
  const mergedData = { ...child };

  // Iterate over each property in parent extra_filter
  for (const property in parent) {
    const parentProperty = parent[property];

    // Check if parent property is in child property or not
    if (mergedData[property]) {
      // Check if property has a 'selected' array
      if (parentProperty && parentProperty.selected) {
        // Update the 'value' property in child with the 'selected' array
        mergedData[property] = {
          ...mergedData[property],
          selected: _.clone(parentProperty.selected) || null
        };
      } else {
        mergedData[property] = {
          ...mergedData[property],
          selected: null
        };
      }
    }
  }

  return mergedData;
}

function getParentFilterData(payload, store, currentStore) {
  const { from } = payload;
  console.log('getParentFilterData', from, currentStore);
  const {
    extra_filter: parent_extra_filter,
    selected: parent_selected,
    LOB,
    LOBTeamAgent,
    LOBTeam,
    rangeDate
  } = store.getState()[ROUTES[from]];
  const { extra_filter, selected } = store.getState()[currentStore];

  return {
    extra_filter: mergeObjectData(extra_filter, parent_extra_filter),
    selected: merge(selected, parent_selected),
    LOB,
    LOBTeam,
    LOBTeamAgent,
    rangeDate
  };
}

export { getParentFilterData };
